import { HeaderService } from "./header.service";
import { RegistrationStore } from "@app/pages/registration/stores/RegistrationStore";
import { TabTrapService } from "@app/services/TabTrap.service";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject, NgZone,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { DOCUMENT } from "@angular/common";
import { PushPopService } from "@app/services/push.pop.service";
import { CommonService } from "@app/services/CommonService";
import { NavigationEnd, Router } from "@angular/router";

/*
Example of header-bar HTML:
 <header-bar>
    <header-bar-left><a href="#" ng-click="vm.testClick()">Left</a></header-bar-left>
    <header-bar-title>Properties</header-bar-title>
    <header-bar-right><a href="#" ng-click="vm.testClick()">Right</a></header-bar-right>
 </header-bar>
*/

@Component({
    selector: 'app-moo-header',
    template: require('./header.html')
})
export class HeaderComponent implements AfterViewInit, OnDestroy, OnInit {

    @ViewChild('headerContentTitle') title_container: ElementRef;
    @ViewChild('headerLeftContainer') leftHTML_container: ElementRef;
    @ViewChild('headerRightContainer') rightHTML_container: ElementRef;

    private bodyElement;
    public showBack: boolean = false;
    public navOpen: boolean = false;
    public title: String;
    public items: any;
    public mobileNavItems: any[] = [];
    public currentSection: any;

    displayRightContent: boolean;
    mobileRegistrationPage: string;
    isDropdownWhenWebFullVar: boolean = false;
    pushPopUpdateSuccessSubscription
    routerSubscription

    constructor(
        @Inject(WindowToken) private $window,
        @Inject(ElementRef) private $elementRef: ElementRef,
        @Inject(DOCUMENT) private $document: Document,
        @Inject(TabTrapService) private tabTrapService: TabTrapService,
        @Inject(HeaderService) private headerService: HeaderService,
        @Inject(RegistrationStore) private registrationStore: RegistrationStore,
        @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef,
        @Inject(PushPopService) private pushPopService: PushPopService,
        @Inject(CommonService) private commonService: CommonService,
        @Inject(Router) private router: Router,
        @Inject(NgZone) private ngZone: NgZone
    ) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {

        this.items = this.pushPopService.getFooterItems();
        this.mobileNavItems = (this.items || []).filter(item => !item.isDropdownWhenWebFull);
        this.currentSection = this.pushPopService.getSection(); // get initial value

        this.bodyElement = this.$document.body;
        this.displayRightContent = false;

        this.headerService.setup(
            ($removedHeaderBar: any) => {

                let leftContent;
                let titleContent;
                let rightContent;

                // always clear out existing content first
                if(this.title_container) this.title_container.nativeElement.innerHTML = "";
                if(this.leftHTML_container) this.leftHTML_container.nativeElement.innerHTML = "";
                if(this.rightHTML_container) this.rightHTML_container.nativeElement.innerHTML = "";

                if ($removedHeaderBar && $removedHeaderBar.nativeElement && $removedHeaderBar.nativeElement.childElementCount > 0) {

                    leftContent = $removedHeaderBar.nativeElement.querySelector('header-bar-left');
                    titleContent = $removedHeaderBar.nativeElement.querySelector('header-bar-title');
                    rightContent = $removedHeaderBar.nativeElement.querySelector('header-bar-right');

                } else if ($removedHeaderBar && $removedHeaderBar.length > 0) {
                    leftContent = $removedHeaderBar[0].querySelector('header-bar-left');
                    titleContent = $removedHeaderBar[0].querySelector('header-bar-title');
                    rightContent = $removedHeaderBar[0].querySelector('header-bar-right');
                }

                // if defined
                if (leftContent) {
                    this.leftHTML_container.nativeElement.append(leftContent);
                }
                // if defined
                if (titleContent) {
                    this.title_container.nativeElement.append(titleContent);
                }
                // if defined
                if (rightContent) {
                    this.rightHTML_container.nativeElement.append(rightContent);
                }

                // must manually set this again because of an intermittent safari/firefox bug when ever 10th or so reload doesn't fire "$rootScope.$on('$stateChangeSuccess')" event so the header doesn't hide correctly
                this.displayRightContent = this.headerService.getDisplayRightContent();
            }
        );

        this.pushPopUpdateSuccessSubscription = this.commonService.pushPopUpdateSuccessSubject$.subscribe(() => {
            this.items = this.pushPopService.getFooterItems();
            this.mobileNavItems = (this.items || []).filter(item => !item.isDropdownWhenWebFull);
            this.currentSection = this.pushPopService.getSection();
        })

        this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.displayRightContent = this.headerService.getDisplayRightContent();

                this.mobileRegistrationPage = '';

                if (event.urlAfterRedirects === "properties") {
                    this.bodyElement.classList.remove('stateShowBack');
                }

            }
        })

        this.changeDetectorRef.detectChanges();
    }

    // override the hardware back button on Android devices
    onBackKeyDown() {
        if (this.bodyElement.classList.contains('stateShowBack')) {
            this.ngZone.run(() => {
                this.goBack();
            });
        }
    };

    toggleSubMenu() {
        if (this.bodyElement.classList.contains('platform-web')) {
            if (this.bodyElement.classList.contains('show-sub-menu')) {
                this.closeSubMenu();
            }
            else {
                this.openSubMenu();
            }
        }
    }

    openSubMenu() {
        this.bodyElement.classList.add('show-sub-menu');
        this.tabTrapService.open(
            [
                this.$document.querySelector('.HOA-Header'), // the header / navbar
                this.$document.querySelector('.HOA-Header-web-nav-menu__wrapper') // the more menu
            ],
            {
                autoFocusEnabled: false,
                onCloseKeyCallback: () => {
                    this.closeSubMenu();
                }
            }
        );
    }

    closeSubMenu() {
        this.bodyElement.classList.remove('show-sub-menu');
        this.tabTrapService.close();
    }

    navToTab(section, isDropdownWhenWebFull) {

        if (isDropdownWhenWebFull) {
            this.isDropdownWhenWebFullVar = true;
            this.toggleSubMenu();
        }
        else {
            this.isDropdownWhenWebFullVar = false;
            this.closeSubMenu();
            this.pushPopService.navToTab(section);
        }
    }

    goBack() {
        if (this.mobileRegistrationPage === '') {
            this.pushPopService.navBack();
        } else {
            this.bodyElement.classList.remove('stateShowBack');
            switch (this.mobileRegistrationPage) {
                case 'register':
                    this.registrationStore.clearAllData();
                    this.router.navigateByUrl('/welcome');
                    break;
                case 'signup':
                case 'registerStep2':
                    this.router.navigateByUrl('/register');
                    break;
                case 'createAccount':
                    this.router.navigateByUrl('/registerStep2');
                    break;
                case 'securityQuestions':
                    this.router.navigateByUrl('/createAccount');
                    break;
                default:
                    this.router.navigateByUrl('/welcome')
            }
        }
    }

    menuChanged(menuChangeValue: string) {
        if (menuChangeValue === 'closeSubMenu') {
            this.closeSubMenu();
        }
    }

    ngOnDestroy() {

        if(this.pushPopUpdateSuccessSubscription) {
            this.pushPopUpdateSuccessSubscription.unsubscribe();
        }

        if (this.routerSubscription){
            this.routerSubscription.unsubscribe();
        }

    }

}

